import SectionTitle from './SectionTitle'
import './SectionTitle.scss'

export default SectionTitle
